<app-loader *ngIf="isDisabled"></app-loader>
<div class="single-row-container">
    <div class="header-row">
        <div class="row w-100 gap-2">
            <div class="col align-content-center">
                <i class="bi bi-building-fill-check"></i>
                <span class="fw-bold ps-2">Location Master</span>
            </div>
            <!-- <div class="col-auto p-0">
                <button *ngIf="this.common.PageRight.IsAdd" type="button" (click)="upload()" class="upload-btn"
                    [disabled]="isDisabled">
                    <i class="bi bi-upload" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Upload':'Loading...'}}
                </button>
            </div> -->
            <div class="col-auto p-0">
                <button *ngIf="this.common.PageRight.IsAdd" type="button" class="upload-btn" [disabled]="isDisabled"
                    (click)="navigateToLocationComponent()">
                    <i class="bi bi-plus" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Add Location':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
    <div class="main-row">
        <div clsss="row" style="width:100%">
            <div class="col-md-12">
                <div class="control-group">
                    <div class="row w-100">
                        <div class="col">
                            <div class="align-items-center d-inline-flex gap-2">
                                <span class="control-label">
                                    <i class="bi bi-list-ul"></i> Status:
                                </span>
                                <ng-select name="Status" [(ngModel)]="Status" placeholder="Status" required
                                    (change)="onchange()" style="width: 10rem;">
                                    <ng-option value="All">All</ng-option>
                                    <ng-option value="Active">Active</ng-option>
                                    <ng-option value="Deactive">Deactive</ng-option>
                                </ng-select>

                                <span class="control-label">
                                    <i class="bi bi-building"></i> Branch:
                                </span>
                                <ng-select name="branch" [items]="BranchMaster" bindLabel="BranchName"
                                    bindValue="BranchMasterID" [(ngModel)]="BranchId" (change)="onchange()"
                                    placeholder="Select Branch" style="width: 20rem;">
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="upload-btn" [disabled]="isDisabled" (click)="getData()">
                                <i class="bi bi-search" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Search':'Loading...'}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="m-3">
        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
            class="customeDatatable table table-bordered">
            <thead class="table-light">
                <tr>
                    <th scope="col">#</th>
                    <th scope="col" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
                    <th scope="col">Branch Name</th>
                    <th scope="col">Client Name</th>
                    <th scope="col">Site Code</th>
                    <th scope="col">Site Name</th>
                    <th scope="col">Active</th>

                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let site of SiteMasterData; let i = index">
                    <th scope="row">{{ i + 1 }}</th>
                    <td [ngClass]="{'colHide': !this.common.PageRight.IsEdit}" class="text-center align-content-center">
                        <button class="btn btn-sm btn-warning" type="button" (click)="onEditClick(site)"><i
                                class="bi bi-pencil-square"></i></button>
                    </td>
                    <td>{{ site['BranchName'] }}</td>
                    <td>{{ site['ClientGroupName'] }}</td>
                    <td>{{ site['SiteCode'] }}</td>
                    <td>{{ site['SiteName'] }}</td>
                    <td>{{ site['Active'] ? 'Yes' : 'No'}}</td>

                </tr>
            </tbody>
        </table>
    </div>

    <div class="sticky-footer flex-shrink-0 bg-white border-top py-2 px-3">
        <div class="row align-items-center">
            <div class="col"></div>
            <div class="col-auto">
                <button *ngIf="this.common.PageRight.IsPrint" type="button"
                    (click)="exportToExcel('Location Master','SiteMaster_data')" class="upload-btn"
                    [disabled]="isDisabled">
                    <i class="bi bi-download" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Site Master':'Loading...'}}
                </button>
            </div>
            <div class="col-auto">
                <button *ngIf="this.common.PageRight.IsPrint" type="button"
                    (click)="exportToExcel('Location Manpower Master','SiteManpower_data')" class="upload-btn"
                    [disabled]="isDisabled">
                    <i class="bi bi-download" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Site Manpower':'Loading...'}}
                </button>
            </div>
            <div class="col-auto">
                <button *ngIf="this.common.PageRight.IsPrint" type="button"
                    (click)="exportToExcel('Location Details','SiteDetails_data')" class="upload-btn"
                    [disabled]="isDisabled">
                    <i class="bi bi-download" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Site Details':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>